import * as Immutable from 'immutable';
import {
  GET_SESSION_REQUESTED,
  GET_SESSION_COMPLETED,
  GET_SESSION_FAILED,
} from '../../actions/session/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: {},
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SESSION_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_SESSION_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_SESSION_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
